import { IMdlCustomDialogConfiguration, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActionsMenuAgRendererComponent, ActionsMenuItem } from '../../covance-ag-grid';
import { AnnouncementEditDialogComponent, ANNOUNCEMENT_EDIT_TOKEN } from './announcement-edit-dialog.component';
import { AnnouncementInfo } from './announcement-info';
import { AnnouncementDeleteDialogComponent, ANNOUNCEMENT_DELETE_TOKEN } from './delete-announcement-dialog.component';

@Component({
    selector: 'common-link-editor-menu-ag-renderer',
    template: require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementsActionsMenuAgRendererComponent extends ActionsMenuAgRendererComponent<AnnouncementInfo> {

    constructor(private readonly dialogService: MdlDialogService) {
        super();
    }

    public createMenuItems(data: AnnouncementInfo): ActionsMenuItem[] {
        {
            return [
                {
                    title: 'Edit',
                    onClick: () => {
                        this.addAnnouncement(data);
                    }
                },
                {
                    title: 'Delete',
                    onClick: () => {
                        this.deleteAnnouncement(data);
                    }
                }
            ];
        }
    }

    private addAnnouncement(announcement: AnnouncementInfo) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: AnnouncementEditDialogComponent,
            providers: [{
                provide: ANNOUNCEMENT_EDIT_TOKEN, useValue: announcement
            }],
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }

    private deleteAnnouncement(announcement: AnnouncementInfo) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: AnnouncementDeleteDialogComponent,
            providers: [{
                provide: ANNOUNCEMENT_DELETE_TOKEN, useValue: announcement
            }],
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }
}